export default "__VITE_ASSET__BdjT1MsB__"